<template>
  <div class="statistic-container" :class="{'statistic-fullscreen':fullscreen}">
    <div class="d-statistic">
      <v-btn icon small class="statistic-edit-btn blue-grey--text" @click="toggleFullscreen">
        <v-icon v-if="fullscreen">mdi-arrow-collapse-all</v-icon>
        <v-icon v-else>mdi-arrow-expand-all</v-icon>
      </v-btn>
      <v-btn icon small class="statistic-table-btn blue-grey--text" @click="tableMode" v-if="with_table"><v-icon>mdi-table</v-icon></v-btn>
      <v-btn icon small class="statistic-delete-btn blue-grey--text" @click="deleteStat" v-if="with_delete"><v-icon>mdi-delete</v-icon></v-btn>
      <highcharts v-if="statistic.lines && statistic.lines.length>0" class="stock" :class="{'hc_container': hasInputs}" :constructor-type="'stockChart'" :options="options" ref="chart" :updateArgs="updateArgs"></highcharts>
      <v-flex xs-12 v-else class="text-xs-center">
        <p class="subheading">{{this.statistic.name}}</p>
        <p class="empty-lines">Данные пока не введены</p>
      </v-flex>
      <div class="text-xs-center mt-2">
        <span>Сумма за выбранный период: {{sum}} </span>
      </div>
      <v-layout row wrap>
        <v-flex xs12 sm7>
          <v-select v-if="statistic.lines" :items="statistic.lines" class="pull-left ml-2" item-text="name" item-value="uniq"
                    hide-details multiple label="Срезы" no-data-text="Значения отсутствуют">
            <v-btn color="primary" small slot="prepend-item" @click="showLines">Показать</v-btn>
            <v-divider slot="prepend-item" class="mt-2"></v-divider>
            
            <template slot="item" slot-scope="{item, tile}">
              <v-list-tile dense>
                <v-list-tile-action style="min-width:30px">
                  <v-checkbox v-model="chosen" :value="item.uniq"></v-checkbox>
                </v-list-tile-action>
                <v-list-tile-avatar style="min-width:40px">
                  <div :style="{background:item.color, height:'20px', width:'20px'}"></div>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title v-html="item.name"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </template>
            
            <template slot="selection" slot-scope="{ item, index }">
              <span v-if="index === 0">{{ item.name }}</span>
              <span v-if="index === 1" class="grey--text caption"> (+ еще {{ chosen.length - 1 }} линии)</span>
            </template>
            <v-divider slot="append-item" class="mb-2"></v-divider>
            <v-btn color="primary" small slot="append-item" @click="showLines">Показать</v-btn>
          </v-select>
        </v-flex>
        <v-flex xs12 sm3>
          <v-select v-if="with_periods" :items="periods" hide-details label="Период"
                    @input="changePeriod" :value="statistic.period_type" no-data-text="Значения отсутствуют">
          </v-select>
        </v-flex>
        <v-flex xs12 sm2 class="text-xs-right align-self-end">
          <v-menu offset-y v-if="sets.length>0">
            <v-btn small class="blue-grey white--text mt-0" slot="activator">Доб. в набор</v-btn>
            <v-list>
              <v-list-tile v-for="(item, index) in sets" :key="index" @click="addToSet(index)">
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
  export default {
    
    name : 'Statistic',
    
    props:{
      statistic:{
        type: Object,
        required: true,
        default: () => { return {
          name: '',
          unit: '',
          id: '',
          period_type: '',
          lines: []
        }}
      },
      height:{
        type: String,
        required: false,
        default: '500'
      },
      with_table:{
        type: Boolean,
        required: false,
        default: false
      },
      with_delete:{
        type: Boolean,
        required: false,
        default: false
      },
      with_periods:{
        type: Boolean,
        required: false,
        default: false
      },
      sets: {
        type: Array,
        required: false,
        default: () => []
      }
    },
    
    created(){
      this.allLines = JSON.parse(JSON.stringify(this.statistic.lines))
      this.statistic.lines.map( line => {this.chosen.push(line.uniq)})
    },
    
    computed:{
      hasInputs(){
        return document.querySelector('.highcharts-input-group')
      }
    },
    
    data(){
      return {
        updateArgs: [true, true, true],
        fullscreen: false,
        sum: null,
        chosen: [],
        allLines: [],
        options: {
          chart: {
            height: this.height,
            type: 'line',
            events: {
              render: function() {
                let descr = document.querySelector('.highcharts-input-group')
                if(descr!=null) descr.removeAttribute('transform')
              },
              load:
                function() {
                  let range = document.querySelectorAll('.highcharts-range-selector');
                  if(range){
                    range.forEach(function(item) {
                      item.setAttribute('type', 'date')
                    })
                  }
                }
            }
          },
          title: {
            text: this.statistic.name
          },
          lang: {
            noData: "Данные пока не введены",
          },
          rangeSelector: {
            selected : 2,
            allButtonsEnabled: true,
            enabled: (this.statistic.lines && this.statistic.lines[0] && this.statistic.lines[0].data.length>0),
            buttons: [
              {
                type: 'week',
                count: 1,
                text : 'Неделя',
                dataGrouping: {
                  forced: false,
                  units: [['day', [1]]]
                }
              }, {
                type: 'month',
                count: 1,
                text : 'Месяц',
                dataGrouping: {
                  forced: false,
                  units: [['week', [1]]]
                }
              }, {
                type: 'all',
                text : 'Все',
                dataGrouping: {
                  forced: false,
                  units: [['month', [1]]]
                }
              }],
            buttonTheme: {
              width: null,
              padding: 5
            },
            inputBoxWidth: 200,
            inputBoxHeight: 18,
            
          },
          xAxis: {
            crosshair: true,
            dateTimeLabelFormats:{
              millisecond: '%H:%M:%S.%L',
              second: '%H:%M:%S',
              minute: '%H:%M',
              hour: '%H:%M',
              day: '%e.%m',
              week: '%e.%m',
              month: '%b \'%y',
              year: '%Y'
            },
            events: {
              afterSetExtremes: (e) => {
                let sum = 0,
                  chartOb = e.target
                chartOb.series.map( series => {
                  if(series.points) series.points.map( (point) => {
                    if (typeof point.x !== 'undefined'){
                      if(point.x >= chartOb.min && point.x <= chartOb.max) sum += point.y
                    }
                    else {
                      if(point[0] >= chartOb.min && point[0] <= chartOb.max) sum += point[1]
                    }
                  })
                })
                this.sum = sum
              },
            }
          },
          yAxis: {
            labels: {
              formatter() {
                return this.value+this.chart.options.unit
              }
            },
            reversed: (this.statistic.invert_chart) ? this.statistic.invert_chart : false
          },
          legend: {
            enabled: false,
            align: 'center',
            backgroundColor: '#fff',
            layout: 'vertical',
            verticalAlign: 'bottom',
            y: 0,
            x: 0,
            maxHeight: 100,
          },
          tooltip: {
            split: false,
            useHTML: true,
            valueSuffix: ' '+this.statistic.unit,
            pointFormat: '<p class="ma-0 pa-0 text-xs-center"><span style="color:{point.color}">\u25CF</span> <b>{point.y} </b></p>',
            dateTimeLabelFormats:{
              millisecond:"%A, %b %e, %H:%M:%S.%L",
              second:"%A, %b %e, %H:%M:%S",
              minute:"%A, %b %e, %H:%M",
              hour:"%e.%m, %H:%M",
              day:"%e.%m.%Y",
              week:"Неделя от %A, %m %e, %Y",
              month:"%m.%Y",
              year:"%Y"
            },
          },
          credits: {
            enabled: false
          },
          plotOptions: {
            spline: {
              marker: {
                radius: 4,
                lineColor: '#666666',
                lineWidth: 1
              }
            },
            series: {
              animation: true,
              dataLabels: {
                enabled: false
              },
              showInNavigator: true
            }
          },
          series: this.statistic.lines,
          unit: (this.statistic.unit)?' '+this.statistic.unit:''
        },
        periods: [
          { value: 0, text: 'Час' },
          { value: 1, text: 'День' },
          { value: 2, text: 'Неделя' },
          { value: 3, text: 'Месяц' }
        ],
        tempSize: { width: 0, height: 0}
      }
    },
    
    methods : {
      showLines(){
        let sum = 0
        this.allLines.map( (line,index) => {
          if (!this.chosen.includes(line.uniq)) {
            this.$refs.chart.chart.series[index].setData([], true)
          } else {
            this.$refs.chart.chart.series[index].setData(line.data, true)
            
            if(this.$refs.chart.chart.series[index].points) this.$refs.chart.chart.series[index].points.map( (point) => {
              if (typeof point.x !== 'undefined'){
                if(point.x >= this.$refs.chart.chart.xAxis[0].min && point.x <= this.$refs.chart.chart.xAxis[0].max) sum += point.y
              }
              else {
                if(point[0] >= this.$refs.chart.chart.xAxis[0].min && point[0] <= this.$refs.chart.chart.xAxis[0].max) sum += point[1]
              }
            })
          }
        })
        
        this.sum = sum
        this.$refs.chart.chart.reflow()
      },
      
      changePeriod(period){
        this.$emit('change-period', { id: this.statistic.id, period_type: period})
      },
      
      addToSet(index){
        this.$store.dispatch('analytics/sets/addStatistic',{
          statistic_id: this.statistic.id,
          type: this.statistic.entity_type,
          sets_list: [this.sets[index].id]
        })
      },
      
      tableMode(){
        this.$emit('table-view', this.statistic.id)
      },
      
      deleteStat(){
        this.$emit('delete-stat', this.statistic.id)
      },
      
      toggleFullscreen(){
        if(!this.fullscreen){
          this.tempSize = {
            width : (this.$refs.chart) ? this.$refs.chart.chart.container.closest('.d-statistic').clientWidth : '550',
            height : (this.$refs.chart) ? this.$refs.chart.chart.container.closest('.d-statistic').clientHeight-25 : '400'
          }
        }
        this.fullscreen = !this.fullscreen
        let width = this.fullscreen ? window.innerWidth : this.tempSize.width
        let height = this.fullscreen ? window.innerHeight-30 : this.tempSize.height
        
        if(this.$refs.chart){
          this.$refs.chart.chart.setSize(width, height-70)
          this.$refs.chart.chart.reflow()
        }
      },
    }
  }
</script>

<style>
  .d-statistic{
    border: 1px solid #e2e2e2;
    position: relative;
    overflow: hidden;
    height: 100%;
    background: #fff;
    padding-bottom: 10px;
  }
  .statistic-edit-btn{
    position: absolute !important;
    left: 5px;
    top: 3px;
    z-index: 1;
    padding: 0;
    margin: 0;
  }
  .statistic-table-btn{
    position: absolute !important;
    left: 35px;
    top: 3px;
    z-index: 1;
    padding: 0;
    margin: 0;
  }
  .statistic-delete-btn{
    position: absolute !important;
    right: 3px;
    top: 3px;
    z-index: 1;
    padding: 0;
    margin: 0;
  }
  .statistic-fullscreen{
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 15;
  }
  .empty-lines{
    font-weight: bold;
    color: #666;
    font-size:13px;
    margin-bottom: 50px;
    padding: 140px 0;
    border-bottom: 1px solid #ccd6eb;
  }
  .inactive{
    opacity: 0.6;
    text-decoration: line-through;
  }
  input.highcharts-range-selector {
    width: 130px !important;
    height: 30px !important;
    padding-top: 2px;
    top: 8px !important;
    border: 1px solid #bdbdbd !important;
    border-radius: 5px;
  }
  .highcharts-range-selector[name="min"] {
    left: auto !important;
    right: 180px !important;
  }
  .highcharts-range-selector[name="max"] {
    left: auto !important;
    right: 10px !important;
  }
  .highcharts-range-input {
    display: none !important;
  }
  .hc_container div:first-child {
    text-align: left !important;
  }
  
  .highcharts-range-label {
    display: none !important;
  }
  
  .hc_container div:first-child:before {
    content: '\421';
    position: absolute;
    width: 10px;
    height: 20px;
    top: 44px;
    right: 325px;
    font-size: 16px;
  }
  
  .hc_container div:first-child:after {
    content: '\41F\43E';
    position: absolute;
    width: 25px;
    height: 20px;
    top: 44px;
    right: 145px;
    font-size: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/apps/analytics_old/components/Statistics/Statistic.vue